import { useState } from "react";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import {
  isApplicationInsightsEnabled,
  trackEvent,
  trackException,
} from "../../telemetry/applicationInsights";
import TelemetryRenderError from "./TelemetryRenderError";
import "./TelemetryTestPanel.css";

const isTelemetryTestPanelEnabled =
  process.env.REACT_APP_TELEMETRY_TEST_PANEL_ENABLED?.toLowerCase() === "true";

const TelemetryTestPanel = () => {
  const [shouldThrowRenderError, setShouldThrowRenderError] = useState(false);

  if (!isTelemetryTestPanelEnabled) {
    return null;
  }

  const trackTestEvent = (): void => {
    trackEvent("TelemetryTestEvent", {
      source: "telemetryTestPanel",
      telemetryEnabled: isApplicationInsightsEnabled(),
    });
  };

  const trackTestException = (): void => {
    trackException(
      new Error("Telemetry test tracked exception"),
      {
        source: "telemetryTestPanel",
      },
      SeverityLevel.Error
    );
  };

  const rejectUnhandledPromise = (): void => {
    void Promise.reject(new Error("Telemetry test unhandled promise rejection"));
  };

  return (
    <>
      <TelemetryRenderError shouldThrow={shouldThrowRenderError} />
      <aside className="telemetryTestPanel" aria-label="Telemetry test panel">
        <p className="telemetryTestPanel__title">Telemetry test</p>
        <button
          className="telemetryTestPanel__button"
          type="button"
          onClick={trackTestEvent}
        >
          Track event
        </button>
        <button
          className="telemetryTestPanel__button"
          type="button"
          onClick={trackTestException}
        >
          Track exception
        </button>
        <button
          className="telemetryTestPanel__button"
          type="button"
          onClick={rejectUnhandledPromise}
        >
          Reject promise
        </button>
        <button
          className="telemetryTestPanel__button"
          type="button"
          onClick={() => setShouldThrowRenderError(true)}
        >
          Render crash
        </button>
      </aside>
    </>
  );
};

export default TelemetryTestPanel;
